<button
  class="btn mb-0"
  [class]="buttonClass"
  [type]="typeAction"
  name="button"
  [disabled]="isSaving || disabled"
  [class.disabled]="disabled"
  (click)="onClick.emit($event)"
  [style.font-size]="textSize"
>
  <span *ngIf="isSaving"><i class="fas fa-circle-notch fa-spin"></i>&nbsp;&nbsp;</span>
  <span *ngIf="iconClass && !isSaving"><i class="fas pe-2" [class]="iconClass"></i>&nbsp;</span>
  <div style="display: contents" #content><ng-content></ng-content></div>
  <div style="display: contents" *ngIf="!content.innerHTML.trim()">
    {{ name }}
  </div>
  <span *ngIf="iconEndClass && !isSaving"
    >&nbsp;<i class="fas ps-2 text-white" [class]="iconEndClass"></i
  ></span>
</button>
